
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Vitry-sur-Seine dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Vitry-sur-Seine certifiée Google Partner, aide les entreprises vitriotes à développer leur visibilité en ligne et à conquérir de nouveaux marchés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Vitry-sur-Seine dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Vitry-sur-Seine certifiée Google Partner, aide les entreprises vitriotes à développer leur visibilité en ligne et à conquérir de nouveaux marchés.",
        },
      ],
    };
  },
};
